import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Dimmer, Form, Icon, Loader } from 'semantic-ui-react';
import store from '../../../store';
import './warehouse.admin.scss';

function AdminWarehouseCountComponent(props: any) {
    const history = useHistory();
    const id = props.match.params.id;

    const [originalWarehouse, setOriginalWarehouse] = useState({ id: null, name: '', count: 0, minCount: 0, slug: '' });
    const [warehouse, setWarehouse] = useState({ id: null, name: '', count: 0, minCount: 0, slug: '' });
    const [fetchedDetails, setFetchedDetails] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [accumulatedAdd, setAccumulatedAdd] = useState(0);

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (!token || token === 'undefined') {
            store.dispatch({ type: 'redirectUrl', data: window.location.pathname });
            history.push('/');
            return;
        }
        getWarehouse();
    }, [id]);

    const getWarehouse = () => {
        const token = localStorage.getItem('adminToken');
        if (!token || token === 'undefined') return;

        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/' + id, {
            method: 'GET',
            headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
        })
            .then((res) => {
                if (res.ok) return res.json();
                throw new Error('Failed');
            })
            .then((resJson) => {
                if (resJson?.warehouse?.id) {
                    setOriginalWarehouse({ ...resJson.warehouse });
                    setWarehouse(resJson.warehouse);
                }
                setFetchedDetails(true);
            })
            .catch((err) => console.error(err));
    };

    const changeHandler = (e: any) => {
        if (e.target.name === 'count') {
            const newValue = parseInt(e.target.value) || 0;
            setAccumulatedAdd(newValue - originalWarehouse.count);
        } else {
            setWarehouse({ ...warehouse, [e.target.name]: e.target.value });
        }
    };

    const addToCount = (amount: number) => {
        setAccumulatedAdd((prev) => prev + amount);
    };

    const resetAccumulated = () => {
        setAccumulatedAdd(0);
    };

    const save = () => {
        const token = localStorage.getItem('adminToken');
        if (!token || token === 'undefined') return;

        const payload = { id: warehouse.id, count: originalWarehouse.count + accumulatedAdd, minCount: warehouse.minCount };

        setLoading(true);
        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/count', {
            method: 'POST',
            headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then((res) => {
                setLoading(false);
                if (!res.ok) {
                    setErrorMsg('Сүлжээнд алдаа гарлаа');
                } else {
                    setErrorMsg('');
                    setSuccessMsg('Амжилттай хадгаллаа');
                    setWarehouse({ ...warehouse, count: originalWarehouse.count + accumulatedAdd });
                    setOriginalWarehouse({ ...originalWarehouse, count: originalWarehouse.count + accumulatedAdd });
                    setAccumulatedAdd(0);
                    setTimeout(() => setSuccessMsg(''), 3000);
                }
            })
            .catch((err) => {
                setLoading(false);
                setErrorMsg('Сүлжээний алдаа');
                console.error(err);
            });
    };

    if (!fetchedDetails) {
        return (
            <div className="page-admin">
                <Dimmer active>
                    <Loader size="medium" />
                </Dimmer>
            </div>
        );
    }

    return (
        <div className="page-admin">
            <section className="admin-warehouse-form">
                <Dimmer active={loading}>
                    <Loader size="medium" />
                </Dimmer>

                <div className="form-group">
                    <a onClick={() => history.push('/mongol/products')}>
                        <Icon name="arrow left" />
                        <span className="underline">Буцах</span>
                    </a>
                </div>
                <div className="form-group">
                    <Link className="underline" to={'/mongol/warehouse-actions/' + warehouse.id}>
                        Үлдэгдлийн түүх
                    </Link>
                </div>
                <div className="form-group">
                    <a className="underline" href={'/product/' + warehouse.slug} target="_blank" rel="noopener noreferrer">
                        Худалдааны линк
                    </a>
                    <h2>{warehouse.name}</h2>
                </div>

                <Form widths="equal">
                    <div className="form-group">
                        {errorMsg ? <div className="error-msg"><Icon name="warning circle" />{errorMsg}</div> : null}
                    </div>
                    <div className="form-group">
                        {successMsg ? <div className="success-msg"><Icon name="checkmark" />{successMsg}</div> : null}
                    </div>
                    <div className="form-group">
                        <div className="label">Үлдэгдэл:</div>
                        <Form.Input
                            type="number"
                            required
                            name="count"
                            value={originalWarehouse.count + accumulatedAdd}
                            min={0}
                            onChange={changeHandler}
                        />
                        <div className="count-controls">
                            <Button.Group>
                                <Button onClick={() => addToCount(1)}>+1</Button>
                                <Button onClick={() => addToCount(10)}>+10</Button>
                                <Button onClick={resetAccumulated} color="orange">
                                    <Icon name="close" />
                                </Button>
                            </Button.Group>
                        </div>
                        <div className="count-display">
                            <div className="original-count" style={{ color: 'red' }}>
                                Анхны утга: {originalWarehouse.count}
                            </div>
                            {accumulatedAdd > 0 && (
                                <div className="new-count" style={{ color: 'green' }}>
                                    Шинэ: {originalWarehouse.count + accumulatedAdd} (+{accumulatedAdd})
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="label">Анхааруулах үлдэгдэл:</div>
                        <Form.Input
                            type="number"
                            required
                            name="minCount"
                            value={warehouse.minCount}
                            min={0}
                            onChange={changeHandler}
                        />
                        <p>
                            <Icon name="info circle" />
                            Бүтээгдэхүүний үлдэгдэл хэмжээ нь тус хэмжээнээс бага болох үед танд имэйл илгээж мэдэгдэнэ
                        </p>
                    </div>
                    <br />
                    <div className="form-group">
                        <Button className="width-100" color="red" onClick={save} disabled={loading}>
                            Хадгалах
                        </Button>
                    </div>
                </Form>
            </section>
        </div>
    );
}

export default AdminWarehouseCountComponent;
